import { PaytrieAPI } from '@paytrie/client'

import { MagicLinkUnauthorizedError } from './MagicLinkUnauthorizedError'

export const getMagicLinkDetails = async ({
  email,
  verifier,
}: {
  email: string
  verifier: string
}): Promise<PaytrieAPI.MagicLinkDetails> => {
  const response = await PaytrieAPI.getMagicLink(verifier, {
    email,
  })

  if (response.status === 401) throw new MagicLinkUnauthorizedError()
  if (response.status !== 200) {
    throw new Error(
      `Failed to load magic link details (status ${response.status})`
    )
  }

  return response.data.data
}
